<template>
    <div class="modal">
        <b-modal v-model="activo" :title="tit" @hiden="activo=false"
            size="md" centered
            button-size="sm" ok-title="ACEPTAR" ok-variant="outline-primary"
            no-close-on-backdrop no-close-on-esc ok-only hide-header-close
            style="border-radius: 10px;"             
        >
        <h6 v-html="msg"></h6>
        </b-modal>      
    </div>
</template>

<script>
export default {
  name: 'modal',
//   props: {
//     tit: { type: String, default: "Información" },
//     msg: { type: String, default: "Mensaje" },    
//   },
  data() {
      return {
        activo: false,
        tit: "Información",
        msg: "Mensaje",

        timeClose: 4000,
      }
  },
  methods: {
      show(tit='Informacion',msg='Texto',time=4000) {
          this.tit=tit;
          this.msg=msg; //+"<br>Contactaremos lo antes posible. <b>Gracias</b>";    
          this.timeClose=time;
          this.activo=true;          
      }
  },
  watch: {
      "activo": function(val) {
        if (val && this.timeClose>0) {
          setTimeout(() => { this.activo = false; }, this.timeClose);
        }
    }
  }

}

</script>
